/** @jsx jsx */
import { Link } from 'gatsby';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { jsx } from 'theme-ui';
import {
  NavItem as navItemStyles,
  NavLink as linkStyles,
  NavDropdown as dropdownStyles,
  NavDropdownItem as dropdownItemStyles,
} from '../Header.styles';

export default function NavItem(props) {
  if (props.type === 'dropdown') return NavDropdownItem(props);
  const { slug, url, title, icon, rel, state, style } = props;
  return (
    <Nav.Item sx={{ ...style, ...navItemStyles }}>
      {slug || url ? (
        <Nav.Link
          as={slug ? Link : undefined}
          to={slug}
          href={url}
          sx={linkStyles}
          rel={rel}
          state={state}
        >
          {title && title ? (
            title
          ) : (
            <i key={icon}>
              <span className={icon} />
            </i>
          )}
        </Nav.Link>
      ) : (
        title
      )}
    </Nav.Item>
  );
}

function NavDropdownItem({ title, icon, items }) {
  return (
    <NavDropdown title={title} sx={dropdownStyles}>
      {items &&
        items.map(item => (
          <NavDropdown.Item
            key={item.slug || item.url}
            as={item.slug ? Link : undefined}
            to={item.slug}
            href={item.url}
            state={item.state}
            sx={dropdownItemStyles}
          >
            {item.title}
          </NavDropdown.Item>
        ))}
    </NavDropdown>
  );
}
